module.exports = __webpack_public_path__ + "asset/gushiActive_1rCXI4Zx.png";